import { render, staticRenderFns } from "./informacionBono.vue?vue&type=template&id=a64b1fa0&scoped=true"
import script from "./informacionBono.vue?vue&type=script&lang=js"
export * from "./informacionBono.vue?vue&type=script&lang=js"
import style0 from "./informacionBono.vue?vue&type=style&index=0&id=a64b1fa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64b1fa0",
  null
  
)

export default component.exports